import { ErrorResponse } from '@gtpl/shared-models/common-models';
// import { AllEndCustomersResponseModel, EndCustomersResponseModel } from '@gtpl/shared-models/masters';
import { Body, Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getConnection, Raw, Repository } from 'typeorm';
import { EndCustomersDTO } from './dto/end-customer.dto';
import { AllEndCustomersResponseModel, BrandsResponseModel, EndCustomerResponseModel, GetAllBrandsResponseModel } from '@gtpl/shared-models/masters';
import { EndCustomers } from './end-customer.entity';
import { Address } from '../customers/address.entity';
import { EndCustomersAdapter } from './dto/end-customer.adapter';
import { EndCustomerRequest } from './dto/end-customer.request';
import { BrandRequest } from './dto/brand.request';
import { Brands } from '@gtpl/shared-models/masters';
import { BrandsInfo } from 'libs/shared-models/masters/src/lib/endCuctomer/brands-model';
import { BrandsRepository } from './brands.repository';
import { CommonResponse } from '@gtpl/shared-models/production-management';
import { FileUploadResponse } from '@gtpl/shared-models/logistics';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';
import appSettings from 'apps/services/config';
import { UnitCodes } from '../unit-codes/unit-codes.entity';
import { Countries } from '../countries/countries.entity';

@Injectable()
export class EndCustomersService {
    constructor(
      private logService:LogsService,
        @InjectRepository(EndCustomers)
        private endCustomersRepository: Repository<EndCustomers>,
        // @InjectRepository(Address)
        // // private addressRepository: Repository<Address>,
        private endCustomersAdapter: EndCustomersAdapter,
        private brandsRepo: BrandsRepository,
        
    ) { }
    /**
     * create or update Customer
     * @param endCustomersDTO 
     * @param isUpdate 
     * @param request 
     */
    async createEndCustomer(endCustomersDTO: EndCustomersDTO, isUpdate: boolean): Promise<EndCustomerResponseModel> {
        try {
            // to check whether Customer exists with the passed  Customer  or not. if isUpdate is false, a check will be done whether a record with the passed Customer is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed Customer  then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
            if (!isUpdate) {
                const EndCustomerEntity = await this.getEndCustomerDetailsWithoutRelations(endCustomersDTO.endCustomerName);
                if (EndCustomerEntity) {
                    throw new EndCustomerResponseModel(false, 11104, 'End Customer already exists');
                }
            }

            const convertedEndCustomerEntity: EndCustomers = this.endCustomersAdapter.convertDtoToEntity(endCustomersDTO, isUpdate);
            const savedEndCustomerEntity: EndCustomers = await this.endCustomersRepository.save(
                convertedEndCustomerEntity
            );

            const savedEndCustomerDto: EndCustomersDTO = this.endCustomersAdapter.convertEntityToDto(savedEndCustomerEntity);
            console.log(savedEndCustomerDto, 'save')
            if (savedEndCustomerDto) {
                // generating resposnse
                const response = new EndCustomerResponseModel(true, isUpdate ? 11101 : 11100, isUpdate ? 'Customer Updated Successfully' : 'End Customer Created Successfully', savedEndCustomerDto);
                const name=isUpdate?'updated':'created'
                const displayValue = isUpdate? 'Customer Updated Successfully': 'Customer Created Successfully'
            const userName = isUpdate? savedEndCustomerDto.updatedUser :savedEndCustomerDto.createdUser;
                const newLogDto = new LogsDto(1,name, 'EndCustomers', savedEndCustomerDto.endCustomerId, true, displayValue,'','', userName)
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return response;
            } else {
                throw new EndCustomerResponseModel(false, 11106, 'Customer saved but issue while transforming into DTO');
            }
        } catch (error) {
            // when error occures while saving the data , the execution will come to catch block.
            // tslint:disable-next-line: typedef
            return error;
        }
    }
    /**
     * get endCustomers by id
     * @param endCustomerName 
     */
    // @LogActions({isAsync: true})
    async getEndCustomerDetailsWithoutRelations(endCustomerName: string): Promise<EndCustomers> {
        // tslint:disable-next-line: typedef
        const EndCustomersResponse = await this.endCustomersRepository.findOne({
            where: { endCustomerName: Raw(alias => ` end_customer_name = "${endCustomerName}" `) },
        });
        if (EndCustomersResponse) {
            return EndCustomersResponse;
        } else {
            return null;
        }
    }
    /**
     * get All EndCustomers Details
     */
    async getAllEndCustomers(req?:UserRequestDto): Promise<AllEndCustomersResponseModel> {
        // const page: number = 1;
        try {
            const endCustomersDTO: EndCustomersDTO[] = [];
            //retrieves all companies
            const endCustomersEntities: EndCustomers[] = await this.endCustomersRepository.find({
                relations: ["addressInfo", "brandsInfo", "currencyInfo"],
                order: { endCustomerName: 'ASC' },
            });
            if (endCustomersEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                endCustomersEntities.forEach(customerEntity => {
                    const convertedendCustomersDto: EndCustomersDTO = this.endCustomersAdapter.convertEntityToDto(
                        customerEntity
                    );
                    endCustomersDTO.push(convertedendCustomersDto);
                });
                const response = new AllEndCustomersResponseModel(true, 11108, "EndCustomers retrieved successfully", endCustomersDTO);
                if(req.createdUser){
                    const newLogDto = new LogsDto(1,'view', 'EndCustomers', 0, true, 'EndCustomers retrieved successfully',req.createdUser,'','',)
                    let res = await this.logService.createLog(newLogDto);
                    console.log(res);
                }
            
            
                return response;
            } else {
                throw new EndCustomerResponseModel(false, 99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }
    async getActiveEndCustomersData(): Promise<AllEndCustomersResponseModel> {
        // const page: number = 1;
        try {
            const endCustomersDTO: EndCustomersDTO[] = [];
            //retrieves all companies
            const endCustomersEntities: EndCustomers[] = await this.endCustomersRepository.find({
                where: { "isActive": true },
                relations: ["addressInfo", "brandsInfo", "currencyInfo"],
                order: { endCustomerName: 'ASC' },
            });
            if (endCustomersEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                endCustomersEntities.forEach(customerEntity => {
                    const convertedendCustomersDto: EndCustomersDTO = this.endCustomersAdapter.convertEntityToDto(
                        customerEntity
                    );
                    endCustomersDTO.push(convertedendCustomersDto);
                });
                const response = new AllEndCustomersResponseModel(true, 11108, "EndCustomers retrieved successfully", endCustomersDTO);
                return response;
            } else {
                throw new EndCustomerResponseModel(false, 99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }
    /**
     * Activate or Deactivate Customer
     * @param endCustomerReq 
     */
    async activateOrDeactivateEndCustomer(endCustomerReq: EndCustomerRequest): Promise<EndCustomerResponseModel> {
        try {
            const endCustomerExists = await this.getEndCustomerById(endCustomerReq.endCustomerId);
            if (endCustomerExists) {
                if (endCustomerReq.versionFlag !== endCustomerExists.versionFlag) {
                    throw new EndCustomerResponseModel(false, 10113, 'Someone updated the current End Customer information.Refresh and try again');
                } else {

                    const endCustomerStatus = await this.endCustomersRepository.update(
                        { endCustomerId: endCustomerReq.endCustomerId },
                        { isActive: endCustomerReq.isActive, updatedUser: endCustomerReq.updatedUser });

                    if (endCustomerExists.isActive) {
                        if (endCustomerStatus.affected) {
                            const endCustomerResponse: EndCustomerResponseModel = new EndCustomerResponseModel(true, 10115, 'End Customer is de-activated successfully');
                            return endCustomerResponse;
                        } else {
                            throw new EndCustomerResponseModel(false, 10111, 'End Customer is already deactivated');
                        }
                    } else {
                        if (endCustomerStatus.affected) {
                            const endCustomerResponse: EndCustomerResponseModel = new EndCustomerResponseModel(true, 10114, 'End Customer is activated successfully');
                            return endCustomerResponse;
                        } else {
                            throw new EndCustomerResponseModel(false, 10112, 'End Customer is already activated');
                        }
                    }
                    // }
                }
            } else {
                throw new EndCustomerResponseModel(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }
    /**
     * get Customer while passing id
     * @param endCustomerId 
     */
    async getEndCustomerById(endCustomerId: number): Promise<EndCustomers> {
        const Response = await this.endCustomersRepository.findOne({
            where: { endCustomerId: endCustomerId },
        });
        if (Response) {
            return Response;
        } else {
            return null;
        }
    }

  

    async getEndCustomerDataById(@Body() endCustomerRequest: EndCustomerRequest): Promise<EndCustomerResponseModel> {
        // const page: number = 1;
        try {
            const endCustomersDTO: EndCustomersDTO[] = [];
            //retrieves all companies
            const endCustomersEntities: EndCustomers = await this.endCustomersRepository.findOne({
                relations: ["addressInfo", "brandsInfo", "currencyInfo"],
                where: { endCustomerId: endCustomerRequest.endCustomerId }
            });

            const endCustomersData: EndCustomersDTO = this.endCustomersAdapter.convertEntityToDto(endCustomersEntities);
            console.log('endCustomersData***************',endCustomersData)
            if (endCustomersData) {
                const response = new EndCustomerResponseModel(true, 11101, 'End Customer retrived Successfully', endCustomersData);
                return response;
            }
            else {
                throw new EndCustomerResponseModel(false, 11106, 'Something went wrong');
            }
            // generating resposnse

        } catch (err) {
            return err;
        }
    }
    async getAllBrands(): Promise<GetAllBrandsResponseModel> {
        try {
            const response: Brands[] = [];
            const brandsData = await this.brandsRepo.find({ order: { brandName: 'ASC' } });
            if (brandsData.length > 0) {
                brandsData.forEach((res => {
                    const data = new Brands(res.brandId, res.brandName);
                    response.push(data);
                }))
                return new GetAllBrandsResponseModel(true, 1001, "Brands data retrived successfully", response);
            }
            else {
                return new GetAllBrandsResponseModel(false, 1010, "No data found. ", response);
            }
        }
        catch (err) {
            return err;
        }
    }
    async getAllActiveBrands(): Promise<GetAllBrandsResponseModel> {
        try {
            const response: Brands[] = [];
            const brandsData = await this.brandsRepo.createQueryBuilder("Brands")
                .select("brand_id AS brandId, brand_name AS brandName")
                .where("is_active = true")
                .groupBy("master_brand_id")
                .addGroupBy("brand_name")
                .orderBy("brand_name", "ASC")
                .getRawMany();
            if (brandsData.length > 0) {
                brandsData.forEach((res => {
                    const data = new Brands(res.brandId, res.brandName);
                    response.push(data);
                }))
                return new GetAllBrandsResponseModel(true, 1001, "Brands data retrived successfully", response);
            }
            else {
                return new GetAllBrandsResponseModel(false, 1010, "No data found. ", response);
            }
        }
        catch (err) {
            return err;
        }
    }


    async getBrandsById(@Body() brandId: number): Promise<BrandsResponseModel> {
        try {
            let response;
            const brands = await this.brandsRepo.findOne({ select: ["brandId", "brandName"], where: { brandId: brandId } });
            if (brands != undefined) {

                response = new BrandsResponseModel(true, 11101, 'Brands retrived Successfully', brands);
            }
            else {
                response = new BrandsResponseModel(false, 1101, 'No data found',);
            }
            return response;

        } catch (err) {
            return err;
        }
    }


    /**
     * get Brand while passing id
     * @param brandId 
     */
    async getBrandsForId(brandId: number) {
        const Response = await this.brandsRepo.findOne({
            where: { brandId: brandId },
        });
        if (Response) {
            return Response;
        } else {
            return null;
        }
    }

    async getAllEndCustomersDropData(): Promise<CommonResponse> {
        try {
            const data = await this.endCustomersRepository.find({ select: ['endCustomerId', 'endCustomerName'], where: { isActive: true } })
            if (data.length > 0) {
                return new CommonResponse(true, 1211, "data retreived sucessfuly", data)
            } else {
                return new CommonResponse(false, 22322, "No data found")
            }
        } catch (error) {
            throw new ErrorResponse(1111, error)
        }

    }

    async updatePath(filePath: string, filename: string, endCustomerId: number): Promise<FileUploadResponse> {
        try {
            const filePathUpdate = await this.endCustomersRepository.update(
                { endCustomerId: endCustomerId },
                { filePath: filePath, fileName: filename },

            );
            if (filePathUpdate.affected > 0) {
                return new FileUploadResponse(true, 11, 'uploaded successfully', filePath);
            }
            else {
                return new FileUploadResponse(false, 11, 'uploaded failed', filePath);
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    async getBrandsForEndCustomerId(req: EndCustomerRequest): Promise<CommonResponse> {
        try {
            let response;
            const brands = await this.brandsRepo.find({select:['masterBrandId','brandName','brandId'],where:{endCustomerId : req.endCustomerId,isActive:true}})
            if (brands != undefined) {
                response = new CommonResponse(true, 11101, 'Brands retrived Successfully', brands);
            }
            else {
                response = new CommonResponse(false, 1101, 'No data found',);
            }
            return response;

        } catch (err) {
            return err;
        }
    }

    async getCountryByEndCustomerId(req: EndCustomerRequest):Promise<CommonResponse>{
        try{
            // const query = `select c.country_name as countryName from ${appSettings.masters_db} .end_customers ec left join ${appSettings.masters_db} .countries c on c.country_id = ec.country_id`
            const companyData = await this.endCustomersRepository.createQueryBuilder("ec")
            .select("ec.country_id as countryId,c.country_name as countryName")
            .leftJoin(Countries,'c','c.country_id = ec.country_id')
            .where(`ec.end_customer_id = ${req.endCustomerId}`)
            .getRawMany();
            return new CommonResponse(true,1,'data retrieved',companyData)
        }catch(err){
            throw err
        }

    }
}
